<template>
  <tr v-if="loaded">
    <td>
      <a v-bind:href="showLink">
        {{ customerPropertyObject.property.data.formatted_address }}</a>
    </td>
    <td>
      <span v-if="isCurrent">Huidig</span>
      {{ timespan }}
    </td>
    <td class="text-right">
      <a-button type="secondary" v-on:click="handleToShow">
        <eye-icon></eye-icon>
      </a-button>
      <a-button type="primary" v-on:click="handleToEdit">
        <pencil-icon></pencil-icon>
      </a-button>
    </td>
  </tr>
</template>
<script>
import customerPropertyApi from '~/api/customer_property'
import moment from 'moment'

export default {
  name: "CustomerPropertyRowComponent",
  props: {
    customerPropertyId: {
      type: Number,
      required: true
    },
  },
  components: {},
  data() {
    return {
      customerPropertyObject: null,
      loaded: false
    }
  },
  mounted() {
    customerPropertyApi.getById(this.customerPropertyId, ['property', 'customer']).then(response => {
      this.customerPropertyObject = response.data;
      this.loaded = true;
    }).catch()
  },
  computed: {
    showLink() {
      return '/customer/' + this.customerPropertyObject.customer_id + '/property/' + this.customerPropertyObject.id;
    },
    isCurrent() {
      return this.customerPropertyObject.is_current;
    },
    timespan() {
      if (this.customerPropertyObject.registration_date) {
        return moment(this.customerPropertyObject.registration_date, moment.ISO_8601).format('D/MM/YYYY')
      } else if (this.customerPropertyObject.municipality_registration_date) {
        return moment(this.customerPropertyObject.municipality_registration_date, moment.ISO_8601).format('D/MM/YYYY')
      }
      return '';
    },
  },

  methods: {
    handleToEdit() {
      window.location.href = '/customer/' + this.customerPropertyObject.customer_id + '/property/' + this.customerPropertyObject.id + '/edit';
    },
    handleToShow() {
      window.location.href = this.showLink
    },
  }
}
</script>

<style scoped>
</style>
